import moment from 'moment';

export default moment.months().map((name, index) => ({
  description: `0${index + 1}`.slice(-2),
  key: `0${index + 1}`.slice(-2),
}));
